import { createEvent, restore, sample } from 'effector'
import { TCreateAchievement } from './types'
import { fx } from '../../../../libs'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const setAchievement = createEvent<TCreateAchievement>()

export const submitCreateAchievement = createEvent<TCreateAchievement>()

export const resetCreateAchievementDone = createEvent()

export const $achievement = restore(setAchievement, {
  name: '',
  imagePath: '',
  priority: '',
  enabledAt: '',
  file: ''
})

export const createAchievement = fx<TCreateAchievement, void>({
  method: 'POST',
  url: '/achievement',
})

export const $createAchievementDone = restore(
  createAchievement.done.map(() => true),
  false,
).reset(resetCreateAchievementDone)

sample({
  clock: submitCreateAchievement,
  fn: (achievement) => ({
    url: `/achievement`,
    formData: { ...achievement },
  }),
  target: createAchievement,
})

sample({
  clock: createAchievement.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: createAchievement.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})
